import type { ReactNode } from 'react';
import { useAuthStatus } from '@/hooks/useAuthStatus';
import { AuthError } from '@/components/ui/auth-error';

interface AuthGuardProps {
  children: ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, error } = useAuthStatus({
    redirectTo: '/admin/login',
    redirectIfAuthenticated: false
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return <AuthError message={error} className="m-4" />;
  }

  if (!isAuthenticated) {
    // The useAuthStatus hook will handle the redirect
    return null;
  }

  return <>{children}</>;
}
